import React, { useState, useEffect, useRef, useCallback } from "react";
import styles from "./FloatingChatButton.module.css";

const FloatingChatButton = ({
  avatarSrc = "/avatarfabiola.gif",
  message = "¡Hola! ¿En qué te ayudo?",
  link = "https://wa.me/5493512369085/?text=¡Hola!",
  messageDelay = 1000,
  messageReappearDelay = 10000,
  hideOnScroll = true,
  hideOnHover = true,
  position = "bottom"
}) => {
  const [showMessage, setShowMessage] = useState(false);
  const hideTimerRef = useRef(null);

  // Función unificada para ocultar mensaje y programar reaparición
  const hideMessageTemporarily = useCallback(() => {
    setShowMessage(false);

    // Limpiar timer anterior si existe
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
    }

    // Programar reaparición después del delay configurado
    hideTimerRef.current = setTimeout(() => {
      setShowMessage(true);
    }, messageReappearDelay);
  }, [messageReappearDelay]);

  useEffect(() => {
    // Timer inicial para mostrar el mensaje
    const initialTimer = setTimeout(() => {
      setShowMessage(true);
    }, messageDelay);

    return () => clearTimeout(initialTimer);
  }, [messageDelay]);

  useEffect(() => {
    // Handler para scroll
    const handleScroll = () => {
      if (hideOnScroll && showMessage) {
        hideMessageTemporarily();
      }
    };

    // Agregar listener de scroll
    if (hideOnScroll) {
      window.addEventListener("scroll", handleScroll);
    }

    // Cleanup
    return () => {
      if (hideOnScroll) {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [hideOnScroll, showMessage, hideMessageTemporarily]);

  useEffect(() => {
    // Cleanup del timer de reaparición al desmontar
    return () => {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const handleMouseEnter = () => {
    if (hideOnHover && showMessage) {
      hideMessageTemporarily();
    }
  };

  return (
    <div
      className={`${styles.chatContainer} ${position === "top" ? styles.top : styles.bottom}`}
      onMouseEnter={handleMouseEnter}
    >
      {showMessage && (
        <div className={styles.messageBubble}>
          {message}
        </div>
      )}
      <button
        className={styles.chatButton}
        onClick={handleClick}
        aria-label="Abrir chat"
      >
        <img
          src={avatarSrc}
          alt="Avatar chat"
          className={styles.avatarImage}
        />
      </button>
    </div>
  );
};

export default FloatingChatButton;
